export default {
  namespaced: true,
  state: {
    EURO: 'Euro (EURO)',
    USD: 'US dollar (USD)',
    GBP: 'Britse pond (GBP)',
    JPY: 'Yen (JPY)',
    BGN: 'c (BGN)',
    CZK: 'Tjechische kroon (CZK)',
    DKK: 'c (DKK)',
    HUF: 'c (HUF)',
    PLN: 'c (PLN)',
    RON: 'c (RON)',
    SEK: 'c (SEK)',
    CHF: 'Zwitserse frank (CHF)',
    NOK: 'c (NOK)',
    HRK: 'c (HRK)',
    RUB: 'Roebel (RUB)',
    TRY: 'c (TRY)',
    AUD: 'c (AUD)',
    BRL: 'c (BRL)',
    CAD: 'c (CAD)',
    CNY: 'c (CNY)',
    HKD: 'c (HKD)',
    IDR: 'c (IDR)',
    ILS: 'c (ILS)',
    INR: 'c (INR)',
    KRW: 'c (KRW)',
    MXN: 'c (MXN)',
    MYR: 'c (MYR)',
    NZD: 'c (NZD)',
    PHP: 'c (PHP)',
    SGD: 'c (SGD)',
    THB: 'c (THB)',
    ZAR: 'c (ZAR)',
    KM: 'c (KM)'
  },
  getters: {
    getAsArray: state => {
      return state.map(c => c)
    }
  }
}
